import { useState, useEffect } from 'react';
import Form from '../form/Form.component';
import { postCorporateCommunicated, getByCorporateCommunicated, putCorporateCommunicated, getPublic } from '../CorporateCommunicated.service';
import { useSnackbar } from '../../../context/Snackbar';
import CorporateCommunicated from '../interfaces/CorporateCommunicated';
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import ParamTypes from '../../../core/interfaces/ParamTypes';
import { INITIAL_VALUES } from '../utils/INITIAL_VALUES';
import Progress from '../../../component/progress/Progress.component';
import { AxiosError, AxiosResponse } from 'axios';
import Button from '../../../component/buttton/Button.component';
import useModal from '../../../hooks/useModal';
import ButtonForm from '../../../component/buttton/ButtonForm.component';
import ButtonLink from '../../../component/buttton/ButtonLink.component';
import GridComponent from '../../../component/grid/GridComponent.component';
import { DisableRegistration } from '../../../core/interfaces/DisableRegistration';
import Historic from '../historic/Historic.component';
import { HistoricInterface } from '../historic/interface/Historic';
import { getHistoric } from '../historic/Historic.service';
import Delete from '../delete/Delete.component';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import { compare } from '../../../utils/order/compare';
import ButtonBackComponent from '../../../component/buttton/ButtonBack.component';

export default function Register({ disabled }: DisableRegistration) {

  let history = useHistory();
  let { id } = useParams<ParamTypes>();
  const { setSnackbar } = useSnackbar();
  const [open, addModal] = useModal();
  const [corporateCommunicated, setCorporateCommunicated] = useState<CorporateCommunicated>(INITIAL_VALUES);
  const [request, setRequest] = useState<boolean>(true);
  const [requestHistoric, setRequestHistoric] = useState<boolean>(disabled || false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [historic, setHistoric] = useState<HistoricInterface[]>([]);
  const [targetAudience, setTargetAudience] = useState<number>(0);

  useEffect(() => {
    if (disabled) {
      getHistoric(id).then(res => {
        setHistoric(res.data.sort((a: HistoricInterface, b: HistoricInterface) => compare(a, b, 'DataLeitura')))
      }).catch((error) => {
        console.log('Erro ao consultar historico!', error);
      }).finally(() => {
        setRequestHistoric(false);
      });
    }
  }, [id, disabled]);

  useEffect(() => {
    if (id) {
      responsePublic();
      response();
    }
  }, [id]);

  const response = async () => {
    await getByCorporateCommunicated(id).then(res => {
      res.data.Tipo = res.data.TextoDetalhe ? 't' : 'i';
      setCorporateCommunicated(res.data);
    }).catch((error) => {
      console.log('Erro ao consultar comunicado!', error);
    }).finally(() => {
      setRequest(false);
    });
  }

  const responsePublic = async () => {
    await getPublic(id).then(res => {
      setTargetAudience(res.data);
    }).catch((error) => {
      console.log('Erro ao consultar publico alvo!', error);
    });
  }

  const onSubmit = async (data: CorporateCommunicated) => {
    setIsSubmitting(true);
    let ids: string[] = [];
    data.GrupoId.map((group: any) => ids.push(group.Id));
    data.GrupoId = ids;
    const response: Promise<AxiosResponse<CorporateCommunicated>> = await id ? putCorporateCommunicated(data) : postCorporateCommunicated(data);

    response.then((res) => {
      setSnackbar({ msg: `Comunicado foi ${id ? 'atualizado' : 'cadastrado'} com sucesso!`, type: 'success' });
      history.push(`/comunicado-corporativo`);
    }).catch((error: AxiosError) => {
      console.log('Error ao submeter comunicado', error);
      setSnackbar({ msg: `Erro ao ${id ? 'atualizar' : 'cadastrar'} comunicado!`, subMsg: error.response?.data.message, type: 'error' });
    }).finally(() => {
      setIsSubmitting(false);
    });
  };

  const setModal = (value: string | undefined) => {
    addModal(value);
  }

  const readingPercentage = (historic: number, publicNumber: number, corporateCommunicated: CorporateCommunicated): String => {
    if (!Number(corporateCommunicated.Privacidade)) {
      return String(publicNumber);
    }
    return String(((!historic || !publicNumber) ? 0 : (historic / publicNumber) * 100).toFixed(2)) + '%';
  }

  if (id && (request || requestHistoric)) {
    return <Progress open={request || requestHistoric} />
  }

  return (
    <Form handleSubmitForm={onSubmit} initialValues={corporateCommunicated} disabled={disabled} >
      <ButtonBackComponent to='/comunicado-corporativo' />
      {disabled && (
        <GridComponent justify="flex-start" alignItems="center" spacing={2} margin="20px 0px 30px 0px">
          <Button
            type="button"
            onClick={() => addModal(open === 'historico' ? undefined : 'historico')}
            title={`${readingPercentage(historic.length, targetAudience, corporateCommunicated)}`}
            icon={<MenuBookIcon fontSize='small' color='inherit' />}
            margin="0px 0px 0px 12px"
            size="medium"
          />

          <ButtonLink size="medium" link={`/comunicado-corporativo/editar-comunicado/${corporateCommunicated?.Id}`} title='Editar' margin="0px 10px" />
          <Button size="medium" type="button" title='Deletar' variant='outlined' onClick={() => setModal(corporateCommunicated.Id)} />

        </GridComponent>
      )}
      {!disabled && <ButtonForm link="/comunicado-corporativo" title="Salvar" disabled={isSubmitting} />}
      <Delete open={open} handleClick={() => addModal(undefined)} />
      <Historic historic={historic} open={open === 'historico'}
        handleClick={() => addModal(open === 'historico' ? undefined : 'historico')}  >
        <Button type="button" title='Fechar' variant='outlined' onClick={() => setModal('')} fullWidth />
      </Historic>
    </Form>
  );
}
